export class Login {
    constructor(
        public codigo: string = '',
        public login: string = '',
        public senha: string = '',
        public id_empresa?: string,
    ) {
    }
}